import PropTypes from 'prop-types';
import cn from 'classnames';
import moment from 'moment';

import './BrandTrackingHealthEmailHistory.scss';

const humanizeTemplate = name => (name ? name.replace(/_/g, ' ').replace(/^./, character => character.toUpperCase()) : 'Email');
const HOLD_REASON_LABEL = { throttle: 'held · throttled', settings: 'held · settings', push: 'held · push', opted_out: 'held · opted out' };
const FAILURE_REASON_LABEL = {
  provider_rejected: 'failed · rejected by Postmark',
  provider_error: 'failed · provider error',
  no_recipient: 'failed · no recipient'
};
// `attempted` is not a failure: the send went out but nothing confirmed delivery either way.
const describeStatus = email => {
  if (email.status === 'held') return HOLD_REASON_LABEL[email.ignoredDueTo] || 'held';
  if (email.status === 'failed') return FAILURE_REASON_LABEL[email.failureReason] || 'failed';
  if (email.status === 'sent') return 'sent';
  return 'attempted · delivery unconfirmed';
};

const BrandTrackingHealthEmailHistory = props => {
  const { emails } = props;

  return (
    <div className='brand-tracking-health-emails-card'>
      <div className='brand-tracking-health-emails-title'>Email history</div>
      {!emails?.length ? (
        <div className='brand-tracking-health-emails-empty'>No tracking emails to this brand in the last 6 months.</div>
      ) : (
        <div className='brand-tracking-health-emails-list'>
          {emails.map(email => (
            <div key={email.id} className='brand-tracking-health-email-row'>
              <span className='brand-tracking-health-email-date'>{moment(email.createdAt).format('MMM D, YYYY')}</span>
              <span className='brand-tracking-health-email-template'>{humanizeTemplate(email.templateName)}</span>
              <span className='brand-tracking-health-email-recipient'>{email.recipientEmail || 'brand contacts'}</span>
              <span className={cn('brand-tracking-health-email-status', `is-${email.status}`)}>{describeStatus(email)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

BrandTrackingHealthEmailHistory.propTypes = {
  emails: PropTypes.array
};

export default BrandTrackingHealthEmailHistory;
